module.exports = ".loader-hidden { visibility: hidden}\n.loader-overlay { position: fixed; width: 100%; top: 0; left: 0; opacity: 1; z-index: 500000; height: 100%; bottom: 0; background: rgba(255, 255, 255, 0.3)}\n.loader-logo { position: fixed; left: 50%; top: 50%; margin: -70px 0 0 -113px; width: 170px; height: 140px }\n.logo-img { position: absolute; left: 50%; top: 50%; margin: -13px 0 0 -70px }\n@media only screen and (max-width: 740px) {\n  .loader-logo{left: 60%}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/loader/loader.component.css
// module id = ./src/app/loader/loader.component.css
// module chunks = main